import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import GLightbox from 'glightbox';

declare var $: any;
declare var imagesLoaded: any;

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements AfterViewInit, OnDestroy {
  portfolioItems = [
    { image: 'assets/images/luxury1.png', title: 'Luxury Villa', subtitle: 'More Spacious' },
    { image: 'assets/images/luxury2.png', title: 'Luxury Villa', subtitle: 'Great Parking Space' },
    { image: 'assets/images/luxury3.png', title: 'Luxury Villa', subtitle: 'New Model' },
    { image: 'assets/images/luxury4.png', title: 'Luxury Villa', subtitle: 'Modern Look' },
    { image: 'assets/images/luxury6.png', title: 'Luxury Villa', subtitle: 'Traditional Look' },
    { image: 'assets/images/luxury8.png', title: 'Luxury Villa', subtitle: 'Fashionable Design' },
    { image: 'assets/images/luxury5.png', title: 'Luxury Villa', subtitle: 'Compact' },
    { image: 'assets/images/luxury7.png', title: 'Luxury Villa', subtitle: 'New Modal' }
  ];

  private glightboxInstance: any;
  private isotopeInstance: any;

  ngAfterViewInit() {
    // Initialize portfolio grid with Isotope
    setTimeout(() => {
      this.initPortfolioGrid();

      // Destroy existing GLightbox instance if it exists
      if (this.glightboxInstance) {
        this.glightboxInstance.destroy();
      }

      this.glightboxInstance = GLightbox({
        selector: 'a[data-group="lightbox-gallery"]',
        loop: true,        // enables left/right navigation
        touchNavigation: true,
        closeButton: true  // cross button
      });
    }, 100);
  }

  private initPortfolioGrid(): void {
    const portfolioWrapper = document.querySelector('.portfolio-wrapper');
    if (!portfolioWrapper) return;

    // Check if jQuery and isotope are available
    if (typeof $ !== 'undefined' && typeof $.fn.isotope === 'function' && typeof imagesLoaded === 'function') {
      $(portfolioWrapper).imagesLoaded(() => {
        // Remove loading class
        $(portfolioWrapper).removeClass('grid-loading');

        // Destroy existing isotope instance
        if (this.isotopeInstance) {
          this.isotopeInstance.isotope('destroy');
        }

        // Initialize Isotope with masonry layout
        this.isotopeInstance = $(portfolioWrapper).isotope({
          layoutMode: 'masonry',
          itemSelector: '.grid-item',
          percentPosition: true,
          stagger: 0,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
      });
    } else {
      // Fallback: just remove loading class if isotope is not available
      console.warn('Isotope or imagesLoaded not available, removing loading class only');
      portfolioWrapper.classList.remove('grid-loading');
    }
  }

  ngOnDestroy() {
    // Clean up GLightbox instance
    if (this.glightboxInstance) {
      this.glightboxInstance.destroy();
    }

    // Clean up Isotope instance
    if (this.isotopeInstance) {
      this.isotopeInstance.isotope('destroy');
    }
  }
}

